import { EVENT_VALUES, STATS } from "./constants";
import { IStatsValue } from "./types";

export const getEventNameByValue = (value: number) => {
  return Object.keys(EVENT_VALUES).find(
    (key) => EVENT_VALUES[key as IStatsValue] === value
  );
};

export const getEventCategoryByName = (name: string) => {
  return STATS.find((stat) => stat.name === name)?.category;
};
